import { useEffect, useState } from "react";
import apiClient from "../../utils/axiosPetition";
import Modal from 'react-modal';
import { alertaGeneral } from "../../utils/alertas";
Modal.setAppElement('#root'); // Para accesibilidad del modal

const ChangePasswordModal = ({ showModalChangePassword, setShowModalChangePassword }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [password, setPassword] = useState({});
    const [error, setError] = useState('');
    const [isSamePassword, setIsSamePassword] = useState('');
    const [someErrorPassword, setSomeErrorPassword] = useState(true);

    const regex = {
        someMayus: /[A-Z]/,
        someNumber: /\d/,
        someSimbol: /[!@#$%^&*()_\-+=\[\\\]|:;"'.,?/`~]/,
        all: /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    };

    const onHandleChangePassword = () => {
        setShowModalChangePassword(!showModalChangePassword);
        if (!showModalChangePassword) {
            setCurrentPassword('');
            setPassword({});
            setError('');
        }
    }

    const onHandleChangeInputPassword = (ev) => {
        switch (ev.target.name) {
            case 'currentPassword':
                setCurrentPassword(ev.target.value);
                break;
            case 'newPassword':
                setPassword({ ...password, newPassword: ev.target.value.trim() });
                setError(validatePassword(ev.target.value));
                setIsSamePassword(password.newPassword !== ev.target.value ? 'Las contraseñas no coinciden' : '');
                break;
            case 'confirmNewPassword':
                setPassword({ ...password, confirmNewPassword: ev.target.value.trim() });
                setIsSamePassword(password.newPassword !== ev.target.value ? 'Las contraseñas no coinciden' : '');
                break;
            default:
                break
        }
    }

    useEffect(() => {
        if (error.length > 0 || isSamePassword.length > 0 || Object.values(password).length === 0 || !currentPassword) {
            setSomeErrorPassword(true);
            return;
        }
        setSomeErrorPassword(false);
    }, [password, currentPassword]);

    const onConfirmChangePassword = (ev) => {
        ev.preventDefault();
        console.log(someErrorPassword);

        if (someErrorPassword) {
            return;
        }

        apiClient.post('/api/clinic/changePassword',
            {
                currentPassword: currentPassword,
                newPassword: password.newPassword,
            }
        ).then((res) => {
            alertaGeneral({
                titulo: res.data.message,
                isError: res.status >= 400
            });
            setShowModalChangePassword(false);
        }).catch((error) => {
            console.log(error);
            alertaGeneral({
                titulo: error.response?.data?.message || 'Error en conexión con el servidor',
                isError: true
            })
        })
    }


    return (
        <Modal
            isOpen={showModalChangePassword}
            onRequestClose={() => setShowModalChangePassword(false)}
            shouldCloseOnOverlayClick={false}
            className="w-full max-w-[320px] mx-auto bg-white p-6 rounded-lg shadow-lg text-center border border-[#6e787aff] focus:outline-none"
            overlayClassName="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-[20]"
        >
            <h2 className="text-lg text-[#1f94c2ff] tracking-wide text-stroke-xs font-black mb-4">Cambio de contraseña</h2>
            <form onSubmit={onConfirmChangePassword}>
                <div className="mb-2 text-left">
                    <label htmlFor="currentPassword" className="text-md block mb-2 font-semibold text-[#70706eff] ">
                        Contraseña actual
                    </label>
                    <input
                        name="currentPassword"
                        placeholder="Contraseña actual"
                        value={currentPassword}
                        type="password"
                        onChange={onHandleChangeInputPassword}
                        required
                        className="w-full px-2 py-1 bg-white border border-[#6e787aff] rounded-lg focus:outline-none"
                    />
                </div>
                <div className="mb-2 text-left">
                    <label htmlFor="newPassword" className="text-md block mb-2 font-semibold text-[#70706eff] ">
                        Nueva contraseña
                    </label>
                    <input
                        name="newPassword"
                        placeholder="Nueva contraseña"
                        value={password.newPassword}
                        type="password"
                        onChange={onHandleChangeInputPassword}
                        required
                        className="w-full px-2 py-1 bg-white border border-[#6e787aff] rounded-lg focus:outline-none"
                    />
                    <span className="text-xs text-wrap text-red-500">{error ? 'Debe tener al menos: ' + error : null}</span>
                </div>
                <div className="mb-2 text-left">
                    <label htmlFor="confirmNewPassword" className="text-md block mb-2 font-semibold text-[#70706eff] ">
                        Confirmar nueva contraseña
                    </label>
                    <input
                        name="confirmNewPassword"
                        placeholder="Confirmar nueva contraseña"
                        value={password.confirmNewPassword}
                        type="password"
                        onChange={onHandleChangeInputPassword}
                        required
                        className="w-full px-2 py-1 bg-white border border-[#6e787aff] rounded-lg focus:outline-none"
                    />
                    <span className="text-xs text-wrap text-red-500">{isSamePassword}</span>
                </div>
                <div className="flex justify-center gap-x-6 mt-4">
                    <button type="submit" disabled={someErrorPassword} className="px-3 py-1 bg-[#1f94c2ff] text-white rounded-lg focus:outline-none border border-[#6e787aff]">
                        Confirmar
                    </button>
                    <button className="px-3 py-1 bg-[#f79865ff] text-white rounded-lg focus:outline-none border border-[#6e787aff]" onClick={onHandleChangePassword}>
                        Cancelar
                    </button>
                </div>
            </form>
        </Modal>
    );

    function validatePassword(password) {
        const errors = [];
        if (!regex.someMayus.test(password)) {
            errors.push("Una mayúscula");
        }
        if (password.length < 8) {
            errors.push("8 caracteres");
        }
        if (!regex.someNumber.test(password)) {
            errors.push("Un número");
        }
        if (!regex.someSimbol.test(password)) {
            errors.push("Un símbolo");
        }

        return errors.length > 0 ? errors.join(" | ") : "";
    }
}

export default ChangePasswordModal;